import React, { useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { IRecruiter } from './CampaignTable'

type Props = {
  show: boolean
  onHide: () => void
  recruiters: IRecruiter[]
}

// Inline styles only: e-mail clients drop CSS classes when the table is pasted
const table: React.CSSProperties = { borderCollapse: 'collapse', fontFamily: 'Arial, sans-serif' }
const cell: React.CSSProperties = { border: '1px solid #000', padding: '4px 12px' }
const header: React.CSSProperties = { ...cell, fontWeight: 'bold' }
const centered: React.CSSProperties = { ...cell, textAlign: 'center' }

// Group / code / supporters per participant, ready to paste into an e-mail
const CampaignResultsModal: React.FC<Props> = ({ show, onHide, recruiters }) => {
  const tableRef = useRef<HTMLTableElement>(null)
  const rows = recruiters.map((r) => ({
    group: r.name,
    code: r.short_user_id,
    supporters: new Set(r.recruited_users.filter((u) => !!u.user_id).map((u) => u.user_id)).size,
  }))

  const copy = async () => {
    const text = [['Gruppe', 'Kode', 'Støttespillere'], ...rows.map((r) => Object.values(r))]
      .map((cols) => cols.join('\t'))
      .join('\n')
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([tableRef.current?.outerHTML || ''], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' }),
        }),
      ])
      toast.success('Tabellen er kopiert. Lim den inn i e-posten.')
    } catch {
      toast.error('Kunne ikke kopiere. Marker tabellen og kopier den manuelt.')
    }
  }

  return (
    <Modal show={show} onHide={onHide} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className='modal-title'>Resultatliste</h5>
        </Modal.Title>
      </Modal.Header>
      <div className='modal-body'>
        <div className='table-responsive mb-6'>
          <table ref={tableRef} style={table}>
            <thead>
              <tr>
                <th style={header}>Gruppe</th>
                <th style={{ ...header, textAlign: 'center' }}>Kode</th>
                <th style={{ ...header, textAlign: 'center' }}>Støttespillere</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.code}>
                  <td style={cell}>{row.group}</td>
                  <td style={centered}>{row.code}</td>
                  <td style={centered}>{row.supporters}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button type='button' className='btn btn-primary authbgcolor' onClick={copy}>
          <i className='fa-duotone fa-copy me-2' />
          Kopier tabell
        </button>
      </div>
    </Modal>
  )
}

export default CampaignResultsModal
